import axios from "axios";
import { getAccessToken, clearStoredAuth } from "../components/auth-context";

const baseURL = process.env.BASE_API_URL;

export const pubHttp = axios.create({
  baseURL
});

export const authenticatedHttpClient = axios.create({
  baseURL
});

let isRedirecting = false;
//Set the response error handler to invalidate auth state and redirect
authenticatedHttpClient.interceptors.response.use(undefined, (error) => {
  if (error.response?.status === 401) {
    clearStoredAuth();
    if (typeof window !== "undefined" && !isRedirecting){
      isRedirecting = true;
      window.location.replace("/login");
    }
  }
  return Promise.reject(error);
});

authenticatedHttpClient.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  const token = getAccessToken();
  if (token){
    //This token format is correct for the API's requirements
    config.headers.Authorization = token;
  } else {
    delete config.headers.Authorization;
  }

  return config;
});

export const getFile = (fileName) => {
  return authenticatedHttpClient
    .post("/get-files", {
      files: [fileName],
    })
    .then((res) => res.data);
};

export const logoutServer = () => {
  return authenticatedHttpClient
    .get("/logout")
    .then((res) => res.data);
}

